<!-- @format -->
<!-- TODOMMH: Move to order module, we might use this as dummy component somewhere else too-->
<template>
    <div class="gst-guest d-flex flex-column">
        <div
            v-if="billingDetails"
            class="gst-guest-section d-flex flex-column">
            <p class="gst-guest-section__text">{{ $t('labels.guestName') }}</p>
            <p class="gst-guest-section__text--bold">{{ guestName }}</p>
        </div>
        <hr class="gst-hr my-4" />
        <div class="gst-guest-section d-flex flex-column align-sm-end flex-sm-row">
            <p
                v-if="hotelRoomType"
                class="gst-guest-section__text--bold">
                {{ hotelRoomType }}
            </p>
            <div class="d-flex">
                <p
                    v-if="hotelAdultsCount"
                    class="gst-guest-section__text mr-1">
                    <span v-if="$vuetify.breakpoint.smAndUp">•</span> {{ adultsCount }}
                    {{ childrenCount }}
                </p>
                <p
                    v-if="hotelMealPlan"
                    class="gst-guest-section__text">
                    • {{ hotelMealPlan }}
                </p>
            </div>
        </div>
        <hr class="gst-hr my-4" />
        <div class="gst-guest-section d-flex flex-column flex-sm-row">
            <div class="d-flex flex-column mr-10 mb-4">
                <p class="gst-guest-section__text mb-1">{{ $t('labels.stayDetails') }}</p>
                <p class="gst-guest-section__text--bold">{{ nightsCount }}, {{ roomsCount }}</p>
            </div>
            <div class="d-flex align-center mt-2 mt-sm-0">
                <div class="d-flex flex-column mr-10">
                    <p class="gst-guest-section__text mb-1">{{ $t('labels.checkIn') }}</p>
                    <p class="gst-guest-section__text--bold mb-1">{{ checkinDate }}</p>
                    <p class="gst-guest-section__text">
                        {{ $t('_common:terms.from') }} {{ checkInTime }}
                    </p>
                </div>
                <div class="d-flex flex-column mr-md-10">
                    <p class="gst-guest-section__text mb-1">{{ $t('labels.checkOut') }}</p>
                    <p class="gst-guest-section__text--bold mb-1">{{ checkoutDate }}</p>
                    <p class="gst-guest-section__text">
                        {{ $t('_common:terms.until') }} {{ checkOutTime }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import i18next from 'i18next';
import dateConstants from '@core/utils/constants/date';
import { parseString as dateUtilsParseString } from '@tenant/app/utils/dateUtils.js';

export default {
    name: 'GuestReservationInfo',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking._components.guestReservationInfo',
    },
    props: {
        billingDetails: {
            type: [Object, null],
            default: null,
        },
        hotelMealPlan: {
            type: [String, null],
            default: null,
        },
        hotelRoomType: {
            type: [String, null],
            default: null,
        },
        hotelNightsCount: {
            type: [Number, null],
            default: null,
        },
        hotelRoomsCount: {
            type: [Number, null],
            default: null,
        },
        hotelAdultsCount: {
            type: [Number, null],
            default: null,
        },
        hotelChildrenCount: {
            type: [Number, null],
            default: null,
        },
        hotelCheckin: {
            type: [Date, null],
            default: null,
        },
        hotelCheckout: {
            type: [Date, null],
            default: null,
        },
        hotelCheckinTime: {
            type: [Date, null],
            default: null,
        },
        hotelCheckoutTime: {
            type: [Date, null],
            default: null,
        },
    },
    computed: {
        guestName() {
            return `${this.billingDetails.firstName} ${this.billingDetails.lastName}`;
        },
        nightsCount() {
            return i18next.t('_common:terms.nightStayWithCount', {
                count: this.hotelNightsCount,
            });
        },
        roomsCount() {
            return i18next.t('_common:terms.roomWithCount', {
                count: this.hotelRoomsCount,
            });
        },
        adultsCount() {
            return i18next.t('_common:terms.adultWithCount', {
                count: this.hotelAdultsCount,
            });
        },
        childrenCount() {
            return this.hotelChildrenCount
                ? ', ' +
                      i18next.t('_common:terms.childrenWithCount', {
                          count: this.hotelChildrenCount,
                      })
                : '';
        },
        checkinDate() {
            return this.formattedDate(this.hotelCheckin);
        },
        checkoutDate() {
            return this.formattedDate(this.hotelCheckout);
        },
        checkInTime() {
            return this.formattedTime(this.hotelCheckinTime);
        },
        checkOutTime() {
            return this.formattedTime(this.hotelCheckoutTime);
        },
    },
    methods: {
        formattedDate(date) {
            return this.$options.filters.date(date, dateConstants.FORMAT.PERIOD_FULL_DOT_SEPARATED);
        },
        formattedTime(time) {
            const parsedTime = dateUtilsParseString(time, dateConstants.FORMAT.TIME_HOUR_MINS);
            return this.$options.filters.time(parsedTime, dateConstants.FORMAT.TIME);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.gst-guest {
    padding: theme-spacing(4);
    border: 1px solid theme-color('senary');

    .gst-guest-section {
        gap: theme-spacing(1) !important;

        p {
            margin: theme-spacing(0);
        }

        .gst-guest-section__text {
            color: theme-color('tertiary');
            font-size: font-size('xs');
            font-weight: font-weight('regular');
        }

        .gst-guest-section__text--bold {
            color: theme-color('quaternary');
            font-size: font-size('s');
            font-weight: font-weight('large');
        }
    }
}
</style>
